import { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';

export default function HeroSection() {
  const [currentText, setCurrentText] = useState(0);
  const texts = ['斗地主', '麻将', '德州扑克', '百家乐', '牛牛'];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentText((prev) => (prev + 1) % texts.length);
    }, 3000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="relative w-full min-h-[620px] md:min-h-[750px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Luxurious%20gaming%20room%20with%20green%20felt%20card%20table%2C%20playing%20cards%20and%20golden%20chips%20scattered%2C%20warm%20golden%20and%20amber%20ambient%20lighting%2C%20dark%20elegant%20interior%20with%20velvet%20and%20wood%20textures%2C%20sophisticated%20casino%20atmosphere%2C%20dramatic%20chiaroscuro%20lighting%2C%20no%20people&width=1800&height=900&seq=hero-bg-kaiyun&orientation=landscape"
          alt="开云棋牌 - 正版棋牌游戏平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/30 to-black/55"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 mb-6 md:mb-8">
            <i className="ri-verified-badge-line text-accent-400 text-sm"></i>
            <span className="text-background-50/90 text-xs md:text-sm font-medium">
              官方正版授权 &middot; 5000万+玩家信赖
            </span>
          </div>

          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 font-heading leading-tight mb-4 md:mb-6">
            畅享经典棋牌
            <br />
            尽在<span className="text-accent-400">开云棋牌</span>
          </h1>

          <div className="flex items-center justify-center gap-2 mb-6 md:mb-8">
            <span className="text-background-50/80 text-base md:text-lg">热门游戏：</span>
            <span
              className="inline-block min-w-[80px] text-lg md:text-xl font-bold text-accent-400 transition-all duration-500"
              key={currentText}
            >
              {texts[currentText]}
            </span>
          </div>

          <p className="text-background-50/70 text-sm md:text-base max-w-xl mx-auto mb-8 md:mb-10 leading-relaxed">
            开云棋牌——集斗地主、麻将、德州扑克等多种经典棋牌游戏于一体的正版平台，
            安全稳定、公平公正，海量玩家在线对战，立即注册领取新人大礼包。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
            <a
              href="#download"
              className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm md:text-base hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer shadow-[0_4px_20px_rgba(200,40,30,0.35)]"
            >
              <i className="ri-download-2-line mr-2"></i>
              立即下载
            </a>
            <Link
              to="/categories"
              className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-background-50/10 backdrop-blur-sm border border-background-50/20 text-background-50 font-medium text-sm md:text-base hover:bg-background-50/20 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-gamepad-line mr-2"></i>
              浏览游戏
            </Link>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10 mt-10 md:mt-12">
            {[
              { num: '5000万+', label: '注册用户' },
              { num: '200万+', label: '日活玩家' },
              { num: '50+', label: '游戏种类' },
            ].map((stat, idx) => (
              <div key={idx} className="text-center">
                <div className="text-xl md:text-2xl font-bold text-background-50 font-heading">
                  {stat.num}
                </div>
                <div className="text-xs md:text-sm text-background-50/60 mt-1">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-s-line text-2xl text-background-50/50"></i>
      </div>
    </section>
  );
}